import { optionalToJS } from './utils';

const channelFromId = (state, id) => {
  if (state.channels.ids.includes(id)) {
    return state.entities.getIn(['channels', id.toString()]);
  }
};

export const getChannel = (state, id) => {
  if (state.entities.getIn(['channels']) && state.channels) {
    return optionalToJS(channelFromId(state, id));
  }
};

const channelsFromIds = (state, ids) => ids.map(id => channelFromId(state, id));

const channelsAll = (state) => channelsFromIds(state, state.channels.ids);

export const getChannels = (state) => channelsAll(state).toJS();

export const isFetchingChannels = (state) => state.channels.isFetching;



const channelMatchesQuery = (playlist, query) =>
  playlist.get("name").toLowerCase().includes(query)


const channelFilterFunction = (query) => (playlist) =>
  channelMatchesQuery(playlist, query)

const filteredChannelsByQuery = (state, query) => {
  let filteredChannels = channelsAll(state);
  query = query.trim().toLowerCase();


  if (query !== "") {
    filteredChannels = filteredChannels.filter(
      channelFilterFunction(query)
    );
  }

  return filteredChannels;
};
const filteredChannels = (state, query) => {
  return filteredChannelsByQuery(state, query);
};
export const getFilteredChannels = (state, query) => filteredChannels(state, query).toJS();



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/selectors/channels.js